<template>
  <el-tooltip placement="top" v-bind="attr">
    <div slot="content" v-if="!content">
      <slot name="content" />
    </div>
    <el-button class="z-button--icon" type="text" @click="clickHandler">
      <i :class="icon" class="iconfont"></i>
    </el-button>
  </el-tooltip>
</template>
<script>
export default {
  name: 'ZIconTooltip',
  props: ['content', 'icon'],
  computed: {
    attr() {
      if (this.content) {
        return {content: this.content}
      }
      return {}
    }
  },
  methods: {
    clickHandler(event) {
      this.$emit('click', event)
    }
  }
}
</script>
<style lang="scss" scoped>
.z-button--icon {
  padding: 0;
}
</style>
